import MengLingFeng from "../Assets/MengLingFeng.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",

  boxShadow: 24,
  p: 4,
};

function Card1() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={MengLingFeng}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Mengling ‘Mornin’ Feng</h2>
        <br />
        <p className="card-sub-name-style">
          Director of AI for Public Health,
          <br />
          Saw Swee Hock School of Public Health, NUS
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Mengling ‘Mornin’ Feng</h2>
            <br />
            <h3>
              Director of AI for Public Health, Saw Swee Hock School of Public
              Health, NUS
            </h3>
            <br />
            <p>
              Mengling “Mornin” Feng is an Associate Professor at the National
              University of Singapore (NUS), where he directs the AI for Public
              Health (AI4PH) Program and leads the Biostatistics, Modelling, AI,
              and Data Analytics (B.MAD) domain. Specializing in healthcare AI,
              Dr. Feng’s research centers on innovative solutions in medical
              imaging analysis, treatment recommendation systems, and clinical
              text processing. He actively participates in international
              collaborations and serves as Chair of the Singapore Chapter of the
              Observational Health Data Sciences and Informatics (OHDSI)
              consortium, promoting standardized healthcare data practices.
              <br />
              <br />
              Dr. Feng earned his Ph.D. from Nanyang Technological University
              and completed postdoctoral training at Harvard-MIT. His
              significant contributions have earned him accolades, including the
              Excellent Youth Award at the World Health Forum, the Trailblazer
              Award by Singapore’s Ministry of Digital Development and the NUS
              Innovation Venture Creation (IVC) - Provost’s Innovation Chair
              Professor Award.
              <br />
              <br />
              Since joining NUS in 2017, Dr. Feng has secured over SGD 10
              million in research and translation funding as Lead Principal
              Investigator, Theme Principal Investigator, and Co-Principal
              Investigator. He has published nearly 200 papers in top-tier
              conferences and journals, attracting over 15,000 citations. Dr
              Feng is among the top 2% most cited scientists in 2025.
              Additionally, Dr. Feng has been the lead organizer of the annual
              Singapore Healthcare AI Datathon for the past seven years, drawing
              thousands of interdisciplinary researchers from the region.
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card1;
